var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menucontrol-scroll fixed-top"},[_c('Banner'),_c('ResouceIframe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }